/**
 * Error page component
 */
import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { select } from '@angular-redux/store';
import { Observable, Subscription } from '@shared/rx';
import { ToasterService } from 'angular2-toaster';

import { IErrorPageType } from '@shared/types';
import { I18n } from '@app/i18n/strings-keys';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-error-page',
  templateUrl: 'error-page.component.html',
  styleUrls: ['error-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class XVIErrorPageComponent implements OnInit, OnDestroy {
  @select(['ui', 'errorPage']) public errorObs: Observable<IErrorPageType>;
  @select(['notifications']) public notificationsObs: Observable<any>;
  public defaultErrorTitle: string = I18n.ErrorMessages.UnexpectedError;
  public subscriptions: Subscription[] = [];

  public constructor(private toastService: ToasterService) {}

  public ngOnInit(): void {
    this.subscriptions.push(
      this.notificationsObs.subscribe(() => {
        this.toastService.clear();
      }),
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
